import { useTheme } from '@emotion/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ListItem } from '@mui/material';
import List from '@mui/material/List';
import { useLocation } from 'react-router-dom';
import { ErrorBoundaryXcala } from '../../../ErrorBoundaryXcala';
import {
  AccordionMenu,
  AccordionSummaryMenu,
  CircleBullet,
  ListItemButtonAccordion,
  ListItemButtonWallet,
  ListItemIcons,
  ListItemWallet,
  ListItemWrapper,
  TypographyAccordion,
  TypographyReferrals,
} from '../Layouts/StyledComponentsMenu';
import { WalletOpenDrawer } from './WalletOpenDrawer';

export const AccordionItem = ({
  open,
  menuItem,
  expanded,
  handleAccordionChange,
  handleNavigate,
  handleNavigateWallet,
}) => {
  const theme = useTheme();
  const location = useLocation();
  const pathname = location.pathname;

  const handleItemClick = url => {
    handleNavigate(url);
  };

  const isActiveSubItem = subItem => {
    const currentPath = pathname.toLowerCase();
    const mainMatch =
      typeof subItem.url === 'string' && currentPath.startsWith(subItem.url.toLowerCase());
    const aliasMatch = Array.isArray(subItem.aliasUrls)
      ? subItem.aliasUrls.some(alias => currentPath.startsWith(alias.toLowerCase()))
      : false;

    if (currentPath.startsWith('/completeregistration') && menuItem.name === 'Caja') {
      return false;
    }
    return mainMatch || aliasMatch;
  };

  const hasActiveSubItem = menuItem.subMenu.some(isActiveSubItem);

  return (
    <ListItemWrapper disablePadding>
      <AccordionMenu
        expanded={expanded === menuItem.name}
        onChange={handleAccordionChange(menuItem.name)}>
        <AccordionSummaryMenu
          isActive={open && hasActiveSubItem}
          expandIcon={<ExpandMoreIcon color='white' />}>
          <ListItemIcons sx={{ color: theme.palette.white.main }}>{menuItem.icon}</ListItemIcons>
          <TypographyAccordion>{menuItem.name}</TypographyAccordion>
        </AccordionSummaryMenu>

        <List disablePadding>
          {menuItem.name !== 'Caja' ? (
            menuItem.subMenu.map(subItem => {
              const isActive = isActiveSubItem(subItem);
              return (
                <ListItem key={subItem.id} disablePadding sx={{ boxShadow: isActive ? 2 : 0 }}>
                  <ListItemButtonAccordion
                    onClick={() => handleItemClick(subItem.url)}
                    isActive={isActive}>
                    {['Productos', 'Mi cuenta'].includes(menuItem.name) && <CircleBullet />}
                    <TypographyReferrals>{subItem.btnNameSub}</TypographyReferrals>
                  </ListItemButtonAccordion>
                </ListItem>
              );
            })
          ) : (
            <ErrorBoundaryXcala padding={1} width='100%' height='100%'>
              <ListItemWallet disablePadding>
                {menuItem.subMenu.map(subItem => {
                  const isActive = isActiveSubItem(subItem);
                  return (
                    <ListItemButtonWallet
                      key={subItem.id}
                      onClick={() => handleNavigateWallet(subItem.url)}
                      isActive={isActive}>
                      <WalletOpenDrawer subItem={subItem} />
                    </ListItemButtonWallet>
                  );
                })}
              </ListItemWallet>
            </ErrorBoundaryXcala>
          )}
        </List>
      </AccordionMenu>
    </ListItemWrapper>
  );
};
